import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import Pagination from '@mui/material/Pagination'
import PaginationItem from '@mui/material/PaginationItem'
import Stack from '@mui/material/Stack'
import * as React from 'react'

interface Props {
  page: number
  onChange: (e: React.ChangeEvent<unknown>, v: number) => void
  hideNextButton: boolean
  numberOfResults: number
  itemsPP: number
}
export const PaginationSettings = {
  page: 1,
  prev: 0,
  itemsPPDirectory: 10,
  itemsPPSearch: 10,
}

export default function CustomIconPagination({
  page,
  onChange,
  hideNextButton,
  numberOfResults,
  itemsPP,
}: Props) {
  //const count = numberOfResults >= itemsPP ? page + 1 : page != 1 ? page - 1 : 1
  const count = numberOfResults ? Math.ceil(numberOfResults / itemsPP) : page + 1
  //sibling count controls page display on either side of current selected page
  return (
    <Stack spacing={2}>
      <Pagination
        count={count}
        page={page}
        boundaryCount={page > 1 ? 2 : 0}
        siblingCount={page > 1 ? 1 : 0}
        renderItem={(item) => (
          <PaginationItem slots={{previous: ArrowBackIcon, next: ArrowForwardIcon}} {...item} />
        )}
        onChange={onChange}
        hideNextButton={hideNextButton}
      />
    </Stack>
  )
}
